<div style="page-break-inside: avoid">
<div class="m-t-20">
    <span>
        {{table.header.question}}
    </span>
</div>
<ng-container [ngSwitch]="table.type">
    <ng-template [ngSwitchCase]="'Linear'">
        <detailed-linear-table [table]="table"></detailed-linear-table>
    </ng-template>
    <!-- <ng-template [ngSwitchCase]="'Matrix'">
        <detailed-matrix-table [table]="table"></detailed-matrix-table>
    </ng-template> -->
</ng-container>
</div>